import { polyfill } from 'es6-promise';
polyfill();

import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions.js';
import mutations from './mutations.js';

Vue.use(Vuex)

export const initialState = {
    loading: false,
    optionalExpanded: false,
    providersResultList: [],
    locationData: [],
    genderData: [],
    therapistExperienceData: [],
    culturalExperienceData:[],
    languageData: [],
    selectedRegion: [],
    subRegionsForRegion: [],
    selectedSubRegions:[],
    disableSubRegionDropdown: true,
    selectedGender: [],
    selectedCompetency: [],
    selectedExpertise: [],
    selectedCulturalExpertise: [],
    selectedLanguage: [],
    queryStringArrayToAPI: [],
    queryStringObjectToAPI: {},
    queryStringToAPI: "",
    filterSearchResponse: {},
    messageType: null, // error|success
    message: null, 
    pagination: [],
    paginationShowPrevious: false,
    paginationShowNext: false,
    paginationCurrentPage: 1
};

export default new Vuex.Store({
    state: {...initialState},
    mutations,
    actions,
    getters: {

    }
});